/**
 * Norsk → Svenska. Bygget av `npm run i18n`.
 *
 * Nøkkelen er den norske teksten slik den står i koden. Verdier kan rettes
 * for hånd - skriptet oversetter kun tekster som mangler, og rører aldri en
 * verdi som allerede står her. Fila skrives om i sin helhet ved hver kjøring,
 * så egne kommentarer inni lista forsvinner.
 */
export const name = 'Svenska'

export const strings = {
  '-knappen nederst': '-knappen längst ner',
  '{amount} er lagt til sparegrisen din.': '{amount} har lagts till din spargris.',
  '{amount} er trukket fra. Du har {balance} igjen.':
    '{amount} har dragits av. Du har {balance} kvar.',
  '{amount1} venter på godkjenning — du har {amount2} å bruke av':
    '{amount1} väntar på godkännande — du har {amount2} att spendera',
  '{count} ganger': '{count} gånger',
  '{count} ganger per dag': '{count} gånger per dag',
  '{count} ganger per uke': '{count} gånger per vecka',
  '{days} {unit} igjen': '{days} {unit} kvar',
  '{n} denne uka': '{n} denna vecka',
  '{n} kjøp': '{n} köp',
  '{n} stjerner': '{n} stjärnor',
  '{n} totalt': '{n} totalt',
  '{stars} stjerner på {count} ganger': '{stars} stjärnor på {count} gånger',
  '{stars} stjerner totalt': '{stars} stjärnor totalt',
  '{used}/{limit} brukt': '{used}/{limit} använt',
  '1 gang per dag': '1 gång per dag',
  '1 gang per uke': '1 gång per vecka',
  '1 stjerne = {sum}': '1 stjärna = {sum}',
  'Aldri': 'Aldrig',
  'Alle': 'Alla',
  'Alle barna': 'Alla barnen',
  'Alle bidrar mot samme tall. Ingen taper.': 'Alla bidrar till samma antal. Ingen förlorar.',
  'Alltid': 'Alltid',
  'alt lagres kun i denne nettleseren.': 'allt lagras endast i denna webbläsare.',
  'Alt på plass, gulvet fritt': 'Allt på plats, golvet fritt',
  'Alt som har gått inn og ut.': 'Allt som har gått in och ut.',
  'Angre': 'Ångra',
  'Angre utbetaling': 'Ångra utbetalning',
  'Angre utbetalingen? Beløpet trekkes fra saldoen igjen.':
    'Ångra utbetalningen? Beloppet dras från saldot igen.',
  'Annet': 'Annat',
  'Antall stjerner familien skal samle til sammen.': 'Antal stjärnor familjen ska samla totalt.',
  'automatisk': 'automatiskt',
  'Avbryt': 'Avbryt',
  'Avslutt': 'Avsluta',
  'Avvis': 'Avvisa',
  'Avvist': 'Avvisad',
  'Bare nysgjerrig?': 'Bara nyfiken?',
  'Bare over et beløp': 'Bara över ett belopp',
  'Barn': 'Barn',
  'Barna': 'Barnen',
  'Barnas lommepengekonto — der de lærer å tjene, spare og bruke egne penger. Med gjøremål, stjerner og oversikt for hele familien.':
    'Barnens fickpengskonto — där de lär sig tjäna, spara och spendera egna pengar. Med sysslor, stjärnor och överblick för hela familjen.',
  'barnet': 'barnet',
  'Barnet bruker denne sammen med familiekoden.':
    'Barnet använder denna tillsammans med familjekoden.',
  'Barnet deltar ikke i denne utfordringen': 'Barnet är inte med i den här utmaningen',
  'Barnet fører opp hva det har brukt og på hva, og ser sin egen forbruksoversikt. Ingen kan føre seg under null.':
    'Barnet registrerar vad det har spenderat och på vad, och ser sin egen förbrukningsöversikt. Ingen kan gå under noll.',
  'Barnet må ha et navn': 'Barnet måste ha ett namn',
  'Beløp ({currency})': 'Belopp ({currency})',
  'Beløpet kan ikke være null': 'Beloppet kan inte vara noll',
  'Beløpet legges til saldoen.': 'Beloppet läggs till saldot.',
  'Beløpet trekkes fra saldoen. Skriv det positivt.':
    'Beloppet dras från saldot. Skriv det positivt.',
  'Beskrivelse': 'Beskrivning',
  'Beskrivelse (valgfritt)': 'Beskrivning (valfritt)',
  'Betalingsgrensen er brukt opp. Stjernene føres som vanlig, men uten penger.':
    'Betalningsgränsen är slut. Stjärnorna registreras som vanligt, men utan pengar.',
  'Bla ned og velg': 'Bläddra ner och välj',
  'Bli med': 'Gå med',
  'Bok eller tegneserie teller': 'Bok eller serietidning räknas',
  'Bra jobba!': 'Bra jobbat!',
  'Bruk minus for å trekke fra, f.eks. -50.': 'Använd minus för att dra ifrån, t.ex. -50.',
  'Bruk oppgavelista for oppgaver': 'Använd sysslolistan för sysslor',
  'Brukeren mangler innlogging': 'Användaren saknar inloggning',
  'Brukt denne måneden': 'Spenderat denna månad',
  'Brukt penger': 'Spenderade pengar',
  'Brukt til sammen': 'Spenderat totalt',
  'Bursdagspenger fra bestemor': 'Födelsedagspengar från mormor',
  'Bytt familie': 'Byt familj',
  'Bøker': 'Böcker',
  'Da har du {amount} igjen.': 'Då har du {amount} kvar.',
  'Da åpnes den som en vanlig app, uten nettleserlinje.':
    'Då öppnas den som en vanlig app, utan webbläsarfält.',
  'dag': 'dag',
  'dager': 'dagar',
  'data lagres kun i denne nettleseren': 'data lagras endast i denna webbläsare',
  'deg': 'dig',
  'Dekke bordet': 'Duka bordet',
  'Del': 'Dela',
  'Del denne koden med den andre forelderen:': 'Dela denna kod med den andra föräldern:',
  'Demomodus': 'Demoläge',
  'Den {day}.': 'Dag {day}',
  'Denne er allerede behandlet': 'Den här är redan behandlad',
  'Denne må godkjennes av en voksen først.': 'Detta måste godkännas av en vuxen först.',
  'Denne måneden': 'Denna månad',
  'Denne oppgaven er tildelt noen andre': 'Den här sysslan är tilldelad någon annan',
  'denne uka': 'den här veckan',
  'Det finnes allerede en konto med denne e-posten': 'Det finns redan ett konto med denna e-post',
  'Dette angrer kjøpet barnet førte opp. Fortsette?':
    'Detta ångrar köpet barnet registrerade. Fortsätta?',
  'Dette angrer også oppgaven barnet registrerte. Fortsette?':
    'Detta ångrar också uppgiften barnet checkade av. Fortsätta?',
  'Dette er allerede behandlet': 'Det här är redan behandlat',
  'Dette må en voksen godkjenne først.': 'Detta måste en vuxen godkänna först.',
  'Ditt navn': 'Ditt namn',
  'Du er allerede med i en familie': 'Du är redan med i en familj',
  'Du er logget inn via lenka i e-posten.': 'Du är inloggad via länken i e-posten.',
  'Du er på {place}. plass': 'Du är på {place}:e plats',
  'Du har': 'Du har',
  'Du har alt fått penger for denne {limit} ganger {when}. Den teller fortsatt, og gir stjerner.':
    'Du har redan fått pengar för den här {limit} gånger {when}. Den räknas fortfarande och ger stjärnor.',
  'Du har ikke brukt noe ennå.': 'Du har inte spenderat något än.',
  'Du har ikke så mye igjen': 'Du har inte så mycket kvar',
  'Du kan fortsatt angre en føring i kontoutskriften.':
    'Du kan fortfarande ångra en post i kontoutdraget.',
  'Du leder — delt førsteplass!': 'Du leder — delad förstaplats!',
  'Du leder!': 'Du leder!',
  'E-post': 'E-post',
  'En voksen kan lage en — for eksempel en lesekonkurranse.':
    'En vuxen kan skapa en — till exempel en läsartävling.',
  'Endre': 'Ändra',
  'Endre →': 'Ändra →',
  'Endre barn': 'Ändra barn',
  'Endre kategori': 'Ändra kategori',
  'Endre oppgave': 'Ändra uppgift',
  'Endre postering': 'Ändra post',
  'Endre utfordring': 'Ändra utmaning',
  'Endrer bare pengene. Stjernene barnet fikk står som de er.':
    'Ändrar bara pengarna. Stjärnorna barnet fick står kvar som de är.',
  'Endringen gjelder framover. Allerede godkjente oppgaver beholder sin verdi.':
    'Ändringen gäller framåt. Redan godkända uppgifter behåller sitt värde.',
  'Er den av, går stjernene rett inn på saldoen når barnet huker av.':
    'Är den av går stjärnorna rakt in på saldot när barnet checkar av.',
  'Et felles mål må ha et måltall': 'Ett gemensamt mål måste ha ett måltal',
  'Etterpå oppretter du en ny familie, eller blir med i en du har fått invitasjonskode til.':
    'Sedan skapar du en ny familj, eller går med i en som du har fått en inbjudningskod till.',
  'F.eks. «gjort mens mobilen lå til lading»': 'T.ex. «gjort medan mobilen laddade»',
  'F.eks. «hvem leser mest fram til jul», et felles mål familien jobber mot, eller et personlig mål for hvert barn.':
    'T.ex. «vem läser mest fram till jul», ett gemensamt mål familjen jobbar mot, eller ett personligt mål för varje barn.',
  'F.eks. «tok også under senga»': 'T.ex. «tog även under sängen»',
  'F.eks. ukelønn eller gave.': 'T.ex. veckopeng eller present.',
  'Familie': 'Familj',
  'Familiekode — barna bruker denne for å logge inn':
    'Familjekod — barnen använder denna för att logga in',
  'Familien': 'Familjen',
  'Familienavn': 'Familjenamn',
  'Fant ikke barnet': 'Hittade inte barnet',
  'Fant ikke oppgaven': 'Hittade inte sysslan',
  'Fant ikke posteringen': 'Hittade inte posten',
  'Fant ikke registreringen': 'Hittade inte registreringen',
  'Fant ikke utfordringen': 'Hittade inte utmaningen',
  'Fant ikke uttaket': 'Hittade inte uttaget',
  'Fant ingen familie med den koden': 'Hittade ingen familj med den koden',
  'Fant ingen språk som matcher søket.': 'Hittade inga språk som matchar sökningen.',
  'Fant ingen utbetaling å angre': 'Hittade ingen utbetalning att ångra',
  'Farge': 'Färg',
  'Farge {color}': 'Färg {color}',
  'Fast beløp': 'Fast belopp',
  'Fast lommepenger': 'Fasta fickpengar',
  'Fast lommepenger som ble satt inn automatisk.': 'Fasta fickpengar som sattes in automatiskt.',
  'Faste lommepenger må være mer enn null': 'Fasta fickpengar måste vara mer än noll',
  'Feil e-post eller passord': 'Fel e-post eller lösenord',
  'Feil PIN-kode': 'Fel PIN-kod',
  'Felles mål': 'Gemensamt mål',
  'Felles måltall': 'Gemensamt måltal',
  'Ferdig': 'Klar',
  'Ferdige': 'Klara',
  'Figur': 'Figur',
  'for {count} min siden': 'för {count} min sedan',
  'for {count} t siden': 'för {count} tim sedan',
  'For foreldre': 'För föräldrar',
  'Forelder': 'Förälder',
  'Foreldrene dine har slått av at du kan føre opp kjøp selv':
    'Dina föräldrar har stängt av att du kan registrera köp själv',
  'Fortsett': 'Fortsätt',
  'Fra': 'Från',
  'Fredag': 'Fredag',
  'Fritt opp til ({currency})': 'Fritt upp till ({currency})',
  'Følger stjernekursen': 'Följer stjärnkursen',
  'Før opp kjøpet': 'Registrera köpet',
  'Føres som godkjent med én gang.': 'Registreras som godkänd direkt.',
  'Ført opp!': 'Registrerat!',
  'Gangene utover dette gir stjerner, men ingen penger. Nyttig i utfordringer, der alt barnet gjør skal telle.':
    'Gångerna utöver detta ger stjärnor, men inga pengar. Bra i utmaningar, där allt barnet gör ska räknas.',
  'Gave til noen': 'Present till någon',
  'Gir': 'Ger',
  'gir bare stjerner nå': 'ger bara stjärnor nu',
  'gir ingen stjerner': 'ger inga stjärnor',
  'Gjøremål': 'Sysslor',
  'Gjøremålet er registrert': 'Sysslan är registrerad',
  'Glemt passord?': 'Glömt lösenord?',
  'Godkjenn': 'Godkänn',
  'Godkjent': 'Godkänd',
  'Godteri': 'Godis',
  'Går ikke lenger enn den 28., slik at februar aldri hopper over en utbetaling.':
    'Går inte längre än den 28:e, så att februari aldrig hoppar över en utbetalning.',
  'Har du allerede konto?': 'Har du redan konto?',
  'Har du ikke konto?': 'Har du inget konto?',
  'Har invitasjon': 'Har inbjudan',
  'Hei, {name}!': 'Hej, {name}!',
  'Hei!': 'Hej!',
  'Hele appen vises på dette språket for hele familien':
    'Hela appen visas på detta språk för hela familjen',
  'Hele tiden': 'Hela tiden',
  'Historikk': 'Historik',
  'Hjemme': 'Hemma',
  'Hva er én stjerne verdt? ({currency})': 'Vad är en stjärna värd? ({currency})',
  'Hva gikk pengene til?': 'Vad gick pengarna till?',
  'Hva kjøpte du? (valgfritt)': 'Vad köpte du? (valfritt)',
  'Hva skal gjøres?': 'Vad ska göras?',
  'Hvem er du?': 'Vem är du?',
  'Hvem er med?': 'Vem är med?',
  'Hvem kan gjøre den?': 'Vem kan göra den?',
  'Hvem leser mest?': 'Vem läser mest?',
  'Hver gang': 'Varje gång',
  'Hver måned': 'Varje månad',
  'Hver uke': 'Varje vecka',
  'Hvert barn får sitt eget tall, og rangeres på hvor langt de er kommet mot sitt. Jevner ut aldersforskjeller.':
    'Varje barn får sitt eget tal, och rankas efter hur långt de kommit mot sitt. Jämnar ut åldersskillnader.',
  'Hvilke oppgaver teller?': 'Vilka uppgifter räknas?',
  'Hvilken dag?': 'Vilken dag?',
  'Hvilken dato?': 'Vilket datum?',
  'Hvor mye brukte du?': 'Hur mycket spenderade du?',
  'Hvor ofte gir den penger?': 'Hur ofta ger den pengar?',
  'Hvor ofte kan den gjøres?': 'Hur ofta kan den göras?',
  'i dag': 'i dag',
  'I dag {time}': 'I dag {time}',
  'I går {time}': 'I går {time}',
  'Ikke innlogget': 'Inte inloggad',
  'Ikke nå': 'Inte nu',
  'Ikon': 'Ikon',
  'Ingen': 'Inga',
  'Ingen barn er lagt til ennå.': 'Inga barn tillagda ännu.',
  'Ingen barn er lagt til i denne familien ennå.': 'Inga barn har lagts till i denna familj ännu.',
  'Ingen barn lagt til ennå.': 'Inga barn tillagda ännu.',
  'Ingen gjøremål her ennå.': 'Inga sysslor här ännu.',
  'Ingen gjøremål registrert ennå. Trykk på knappen over for å komme i gang!':
    'Inga sysslor avklarade ännu. Tryck på knappen ovan för att komma igång!',
  'Ingen gjøremål å velge mellom.': 'Inga sysslor att välja bland.',
  'Ingen mål': 'Inget mål',
  'Ingen oppgaver ennå.': 'Inga uppgifter ännu.',
  'Ingen oppgaver her.': 'Inga uppgifter här.',
  'Ingen posteringer ennå.': 'Inga poster ännu.',
  'Ingen stjerner samlet i perioden — ingen vinner å kåre.':
    'Inga stjärnor samlade under perioden — ingen vinnare att utse.',
  'Ingen utfordringer akkurat nå.': 'Inga utmaningar just nu.',
  'Ingen utfordringer ennå.': 'Inga utmaningar ännu.',
  'Ingenting har skjedd ennå.': 'Inget har hänt ännu.',
  'Innloggingen er ikke gyldig lenger. Logg ut og inn på nytt.':
    'Inloggningen gäller inte längre. Logga ut och in igen.',
  'Innskudd': 'Insättning',
  'Innstillinger': 'Inställningar',
  'Installer': 'Installera',
  'Invitasjonskode': 'Inbjudningskod',
  'Inviter med-forelder': 'Bjud in medförälder',
  'Is på butikken': 'Glass i affären',
  'Ja, barna kan trekke fra selv': 'Ja, barnen kan dra av själva',
  'Ja, jeg har gjort det!': 'Ja, jag har gjort det!',
  'Jeg er barn': 'Jag är barn',
  'Jeg er forelder': 'Jag är förälder',
  'Jeg har brukt penger': 'Jag har spenderat pengar',
  'Kan barna føre opp egne kjøp?': 'Kan barnen registrera egna köp?',
  'Kategori': 'Kategori',
  'Kategorien trenger et navn': 'Kategorin behöver ett namn',
  'Kiosk på fotballcup': 'Kiosk på fotbollscupen',
  'Kjøkken': 'Kök',
  'Kjøp over dette beløpet havner til godkjenning hos deg.':
    'Köp över detta belopp går till dig för godkännande.',
  'Kjøp til godkjenning ({count})': 'Köp att godkänna ({count})',
  'Klarte ikke å hente historikken.': 'Kunde inte hämta historiken.',
  'Klarte ikke å hente kontoutskriften.': 'Kunde inte hämta kontoutdraget.',
  'Klarte ikke å logge inn. Prøv igjen.': 'Det gick inte att logga in. Försök igen.',
  'Klær': 'Kläder',
  'Kommer av seg selv, i tillegg til det barnet tjener på gjøremål.':
    'Kommer av sig själv, utöver det barnet tjänar på sysslor.',
  'Konkurranser og mål du er med i.': 'Tävlingar och mål du är med i.',
  'Konkurranser og mål over tid': 'Tävlingar och mål över tid',
  'Kontoutskrift': 'Kontoutdrag',
  'Kopier': 'Kopiera',
  'Kopiert': 'Kopierat',
  'Korriger': 'Justera',
  'Korriger saldo': 'Justera saldo',
  'Korrigering': 'Korrigering',
  'krever godkjenning': 'kräver godkännande',
  'Krever godkjenning': 'Kräver godkännande',
  'kun': 'bara',
  'Kun': 'Bara',
  'Kun barn bruker denne': 'Bara barn använder den här',
  'Kun barn kan registrere oppgaver': 'Bara barn kan registrera sysslor',
  'Kun foreldre kan angre': 'Bara föräldrar kan ångra',
  'Kun foreldre kan angre utbetaling': 'Bara föräldrar kan ångra utbetalningar',
  'Kun foreldre kan endre beløp': 'Bara föräldrar kan ändra belopp',
  'Kun foreldre kan endre posteringer': 'Bara föräldrar kan ändra poster',
  'Kun foreldre kan endre saldo': 'Bara föräldrar kan ändra saldot',
  'Kun foreldre kan gjøre dette': 'Bara föräldrar kan göra det här',
  'Kun foreldre kan godkjenne': 'Bara föräldrar kan godkänna',
  'Kun foreldre kan invitere': 'Bara föräldrar kan bjuda in',
  'Kun foreldre kan lage utfordringer': 'Bara föräldrar kan skapa utmaningar',
  'Kun foreldre kan registrere for et barn': 'Bara föräldrar kan registrera åt ett barn',
  'Kun foreldre kan sette lommepenger': 'Bara föräldrar kan sätta fickpengar',
  'Kun foreldre kan slette': 'Bara föräldrar kan ta bort',
  'Kun foreldre kan slette utfordringer': 'Bara föräldrar kan ta bort utmaningar',
  'Kun foreldre kan utbetale premie': 'Bara föräldrar kan betala ut priset',
  'Kunne ikke kopiere': 'Kunde inte kopiera',
  'Lag den første': 'Skapa den första',
  'Lagre': 'Spara',
  'Lagret': 'Sparat',
  'Lagret!': 'Sparat!',
  'Lar du feltet stå tomt, vises hva slags postering det er.':
    'Lämnar du fältet tomt visas vilken sorts post det är.',
  'Leder': 'Leder',
  'Legg Bonto på hjemskjermen': 'Lägg Bonto på hemskärmen',
  'Legg til': 'Lägg till',
  'Legg til barn': 'Lägg till barn',
  'Legg til barn i familien først.': 'Lägg till ett barn i familjen först.',
  'Legg til på Hjem-skjerm': 'Lägg till på hemskärmen',
  'Leker': 'Leksaker',
  'Lese 15 minutter': 'Läsa 15 minuter',
  'Lesekonkurranse': 'Lästävling',
  'Logg inn': 'Logga in',
  'Logg inn som forelder med hva som helst, eller prøv barneinnlogging med familiekode':
    'Logga in som förälder med vad som helst, eller prova barninloggning med familjekod',
  'Logg ut': 'Logga ut',
  'Lommepenger': 'Fickpengar',
  'Lukk': 'Stäng',
  'Lørdag': 'Lördag',
  'Mamma eller pappa må si ok før stjernene blir til penger.':
    'Mamma eller pappa måste säga ok innan stjärnorna blir till pengar.',
  'Mandag': 'Måndag',
  'Mat og drikke': 'Mat och dryck',
  'Min profil': 'Min profil',
  'Min side': 'Min sida',
  'Minst 8 tegn': 'Minst 8 tecken',
  'Må du godkjenne?': 'Måste du godkänna?',
  'Mål': 'Mål',
  'Målet ble ikke nådd. Du kan likevel utbetale premien manuelt under.':
    'Målet nåddes inte. Du kan ändå betala ut priset manuellt nedan.',
  'Målet er nådd!': 'Målet är nått!',
  'Måltall': 'Måltal',
  'Måltallet er hvor mange stjerner barnet skal samle.':
    'Målet är hur många stjärnor barnet ska samla.',
  'Månedslønn': 'Månadspeng',
  'Månedslønn {amount}': 'Månadspeng {amount}',
  'Navn': 'Namn',
  'Navnet ditt og PIN-koden endres av en voksen.': 'Ditt namn och PIN-koden ändras av en vuxen.',
  'neste {date}': 'nästa {date}',
  'Neste utbetaling {date}': 'Nästa utbetalning {date}',
  'Nesten ferdig': 'Nästan klar',
  'Notat (valgfritt)': 'Anteckning (valfritt)',
  'Ny': 'Ny',
  'Ny familie': 'Ny familj',
  'Ny familie?': 'Ny familj?',
  'Ny kategori': 'Ny kategori',
  'Ny oppgave': 'Ny uppgift',
  'Ny utfordring': 'Ny utmaning',
  'Ny versjon klar': 'Ny version klar',
  'Nytt passord': 'Nytt lösenord',
  'nå nettopp': 'nyss',
  'Når barnet har brukt av sparepengene.': 'När barnet har använt av sparpengarna.',
  'og PIN': 'och PIN',
  'Onsdag': 'Onsdag',
  'Oppdater': 'Uppdatera',
  'Oppgaven er ikke aktiv': 'Sysslan är inte aktiv',
  'Oppgaven er slettet': 'Uppgiften har raderats',
  'Oppgaven må gi stjerner eller penger': 'Uppgiften måste ge stjärnor eller pengar',
  'Oppgaven trenger et navn': 'Uppgiften behöver ett namn',
  'Oppgaver': 'Uppgifter',
  'Opprett en ny familie, eller bli med i en som allerede finnes.':
    'Skapa en ny familj, eller gå med i en som redan finns.',
  'Opprett familie': 'Skapa familj',
  'Opprett konto': 'Skapa konto',
  'Oversikt': 'Översikt',
  'Passord': 'Lösenord',
  'Passordet er oppdatert.': 'Lösenordet har uppdaterats.',
  'Passordet må ha minst 8 tegn': 'Lösenordet måste ha minst 8 tecken',
  'Penger': 'Pengar',
  'penger {count} ganger per dag': 'pengar {count} gånger per dag',
  'penger {count} ganger per uke': 'pengar {count} gånger per vecka',
  'penger 1 gang per dag': 'pengar 1 gång per dag',
  'penger 1 gang per uke': 'pengar 1 gång per vecka',
  'Per dag': 'Per dag',
  'Per uke': 'Per vecka',
  'Personlig mål': 'Personligt mål',
  'PIN-kode (4 siffer)': 'PIN-kod (4 siffror)',
  'PIN-koden må være 4 siffer': 'PIN-koden måste vara 4 siffror',
  'Postering': 'Post',
  'Posteringen er endret': 'Posten är ändrad',
  'Premie': 'Pris',
  'Premie i {currency} (valgfritt)': 'Pris i {currency} (valfritt)',
  'premie utbetalt': 'pris utbetalt',
  'Premien barnet fikk utbetalt.': 'Priset som barnet fick utbetalt.',
  'Premien er allerede utbetalt til dette barnet': 'Priset är redan utbetalt till det här barnet',
  'Premien er utbetalt': 'Priset är utbetalt',
  'Prøv demoen': 'Prova demon',
  'Prøv igjen': 'Försök igen',
  'Pågår': 'Pågår',
  'Registrer': 'Checka av',
  'Registrer et gjøremål': 'Checka av en syssla',
  'Registrer for {name}': 'Checka av åt {name}',
  'Registrer gjøremål': 'Checka av en syssla',
  'Registrert! Stjernene er dine - penger gir den ikke flere ganger nå.':
    'Registrerat! Stjärnorna är dina – fler pengar ger den inte just nu.',
  'Ren konkurranse — den som samler flest stjerner vinner.':
    'Ren tävling — den som samlar flest stjärnor vinner.',
  'Rydde rommet': 'Städa rummet',
  'Saldo': 'Saldo',
  'Saldo etter:': 'Saldo efter:',
  'Saldo nå': 'Saldo nu',
  'Saldo oppdatert': 'Saldo uppdaterat',
  'Se alt →': 'Se allt →',
  'Sendt inn!': 'Skickat in!',
  'Sett inn': 'Sätt in',
  'Sett inn penger': 'Sätt in pengar',
  'Sett ny PIN-kode': 'Sätt ny PIN-kod',
  'Sist godkjent': 'Senast godkänd',
  'Siste dag!': 'Sista dagen!',
  'Siste registreringer': 'Senaste registreringarna',
  'Sjekk e-posten din': 'Kolla din e-post',
  'Skjul': 'Dölj',
  'Skole': 'Skola',
  'Skriv inn e-postadressen din først': 'Skriv in din e-postadress först',
  'Skriv inn en valuta': 'Skriv in en valuta',
  'Skriv inn et beløp': 'Skriv in ett belopp',
  'Skriv inn familiekoden': 'Skriv in familjekoden',
  'Skriv inn familiekoden. Den får du av mamma eller pappa.':
    'Skriv in familjekoden. Den får du av mamma eller pappa.',
  'Skriv inn hvor mye barnet skal få': 'Skriv in hur mycket barnet ska få',
  'Skriv inn hvor mye du brukte': 'Skriv in hur mycket du spenderade',
  'Skriv inn navnet': 'Skriv in namnet',
  'Slett barn': 'Radera barn',
  'Slett kategori': 'Radera kategori',
  'Slett oppgave': 'Radera uppgift',
  'Slett posteringen': 'Radera posten',
  'Slett utfordring': 'Radera utmaning',
  'Slette {name}? All historikk forsvinner.': 'Radera {name}? All historik försvinner.',
  'Slette denne oppgaven? Historikken beholdes.': 'Radera denna uppgift? Historiken behålls.',
  'Slette denne posteringen?': 'Radera denna post?',
  'Slette kategorien? Oppgavene beholdes, men mister kategori.':
    'Radera kategorin? Uppgifterna behålls, men mister kategori.',
  'Slette utfordringen? Registreringene til barna beholdes.':
    'Radera utmaningen? Barnens registreringar behålls.',
  'Slettet': 'Raderad',
  'Sluttdatoen må være etter startdatoen': 'Slutdatumet måste vara efter startdatumet',
  'Smågodt': 'Lösgodis',
  'Sparegrisen din': 'Din spargris',
  'Spill': 'Spel',
  'Språk': 'Språk',
  'Starter i dag': 'Startar idag',
  'Starter om {days} {unit}': 'Startar om {days} {unit}',
  'Starter snart': 'Startar snart',
  'Startsaldo': 'Startsaldo',
  'stjernene fra disse teller i utfordringen': 'stjärnorna från dessa räknas i utmaningen',
  'Stjernene teller som før i totalen og i utfordringer - men det er dette beløpet som havner på saldoen.':
    'Stjärnorna räknas som förut i totalen och i utmaningar - men det är det här beloppet som hamnar på saldot.',
  'Stjerner': 'Stjärnor',
  'stjerner totalt': 'stjärnor totalt',
  'Stjerner totalt': 'Stjärnor totalt',
  'Støvsuge stua': 'Dammsuga vardagsrummet',
  'Synlig for barna': 'Synlig för barnen',
  'Søk etter språk …': 'Sök efter språk …',
  'Søndag': 'Söndag',
  'Så ofte man vil': 'Så ofta man vill',
  'Ta ut': 'Ta ut',
  'Ta ut penger': 'Ta ut pengar',
  'Tast PIN-koden din': 'Ange din PIN-kod',
  'Til {name}': 'Till {name}',
  'til barnet.': 'till barnet.',
  'Til innlogging': 'Till inloggning',
  'Til og med': 'Till och med',
  'Tilbake': 'Tillbaka',
  'Tirsdag': 'Tisdag',
  'tjent': 'intjänat',
  'tjent i utfordringen': 'intjänat i utmaningen',
  'Tok også gangen': 'Tog hallen också',
  'Torsdag': 'Torsdag',
  'Trykk': 'Tryck',
  'Trykk for å oppdatere appen.': 'Tryck för att uppdatera appen.',
  'Trykk på': 'Tryck på',
  'Trykk på det du har gjort.': 'Tryck på det du har gjort.',
  'Trykk på lenka for å fullføre registreringen.':
    'Tryck på länken för att slutföra registreringen.',
  'Tømme oppvaskmaskinen': 'Tömma diskmaskinen',
  'Ugyldig beløpsgrense': 'Ogiltig beloppsgräns',
  'Ugyldig eller utløpt invitasjonskode': 'Ogiltig eller utgången inbjudningskod',
  'Ugyldig forespørsel': 'Ogiltig förfrågan',
  'Ugyldig stjerneverdi': 'Ogiltigt stjärnvärde',
  'Ukelønn': 'Veckopeng',
  'Ukelønn {amount}': 'Veckopeng {amount}',
  'Ukjent': 'Okänd',
  'Ukjent bruker': 'Okänd användare',
  'Ukjent handling': 'Okänd åtgärd',
  'Utbetal {amount}': 'Betala ut {amount}',
  'Utbetale {amount} til {name}?': 'Betala ut {amount} till {name}?',
  'Utbetales manuelt av deg når utfordringen er over — da kan uavgjort håndteres som dere vil.':
    'Betalas ut manuellt av dig när utmaningen är över — då kan oavgjort hanteras som ni vill.',
  'Utbetalingen er angret': 'Utbetalningen har ångrats',
  'Uten kategori': 'Utan kategori',
  'Utfordring': 'Utmaning',
  'Utfordringen har ingen premie': 'Utmaningen har inget pris',
  'Utfordringen trenger et navn': 'Utmaningen behöver ett namn',
  'Utfordringer': 'Utmaningar',
  'Uttak': 'Uttag',
  'Utvendig og innvendig': 'Utvändigt och invändigt',
  'valgt': 'vald',
  'Valuta': 'Valuta',
  'Vaske bilen': 'Tvätta bilen',
  'Vedkommende oppretter konto og velger «Har invitasjon». Koden varer i 14 dager.':
    'Personen skapar ett konto och väljer «Har inbjudan». Koden gäller i 14 dagar.',
  'velg alle': 'välj alla',
  'Velg en dag mellom 1 og 28': 'Välj en dag mellan 1 och 28',
  'Velg en ukedag': 'Välj en veckodag',
  'Velg minst én oppgave som skal telle': 'Välj minst en uppgift som ska räknas',
  'Velg minst ett barn som skal delta': 'Välj minst ett barn som ska delta',
  'Velg nytt passord': 'Välj nytt lösenord',
  'Velg språk': 'Välj språk',
  'Venter på at en voksen godkjenner.': 'Väntar på att en vuxen godkänner.',
  'Venter på godkjenning': 'Väntar på godkännande',
  'Venter på godkjenning ({count})': 'Väntar på godkännande ({count})',
  'Vi har sendt deg en e-post med lenke for å velge nytt passord.':
    'Vi har skickat dig ett e-postmeddelande med en länk för att välja nytt lösenord.',
  'Vi har sendt en bekreftelseslenke til': 'Vi har skickat en bekräftelselänk till',
  'Vil du logge ut?': 'Vill du logga ut?',
  'Vil du skrive noe? (valgfritt)': 'Vill du skriva något? (valfritt)',
  'Vis': 'Visa',
  'Vis meg hvordan': 'Visa mig hur',
  'Vises bak alle beløp i appen, f.eks. kr, SEK, DKK, €, $.':
    'Visas efter alla belopp i appen, t.ex. kr, SEK, DKK, €, $.',
  'Voksne': 'Vuxna',
  'å bruke av.': 'att spendera.',
}
